import { render, staticRenderFns } from "./NewsCategoryList.vue?vue&type=template&id=2583e8d4&scoped=true"
import script from "./NewsCategoryList.vue?vue&type=script&lang=js"
export * from "./NewsCategoryList.vue?vue&type=script&lang=js"
import style0 from "./NewsCategoryList.vue?vue&type=style&index=0&id=2583e8d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2583e8d4",
  null
  
)

export default component.exports